exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2pLAZ{width:100%;margin-top:18px;padding:0 13px}.BCXfW{padding:13px}.UFKMN{margin-bottom:100px}", ""]);

// exports
exports.locals = {
	"root": "_2pLAZ",
	"breadcrumbs": "BCXfW",
	"block": "UFKMN"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/routes/articles/ArticleLeasing.css
// module id = 3268
// module chunks = 21